<template>
  <KTTable
    title="Usuarios"
    subtitle="Lista de usuarios"
    :fields="fields"
    :items="$store.state.users.users"
    @delete="deleteItem($event)"
  ></KTTable>
</template>

<script>
import KTTable from "@/view/content/Table.vue";

import { DELETE_USER } from "@/core/services/store/users.module";

export default {
  name: "users",
  components: {
    KTTable
  },
  data() {
    return {
      fields: [
        {
          key: "firstName",
          label: "Nombre",
          sortable: true
        },
        {
          key: "lastName",
          label: "Apellidos",
          sortable: true
        },
        {
          key: "email",
          label: "Email",
          sortable: true
        },
        {
          key: "actions",
          label: ""
        }
      ]
    };
  },
  methods: {
    deleteItem(item) {
      this.$store.commit(DELETE_USER, item);
    }
  }
};
</script>
